module.exports = __webpack_public_path__ + "static/media/AWS_CloudWatch_Installation_Serra_Labs.cc8120c6.pdf";